import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>For information on coding, refer to the enteral product classification list available at www.emedny.org, click on ‘Provider Manuals’, then ‘DME’, then ‘Provider Communications’. </p>
				
				<div className="button" onClick={()=>this.props.navigate( 'D8')}>Enter Another Code</div>
			</div>
		);
	}
}